import { render, staticRenderFns } from "./FakeUserGameProfile.vue?vue&type=template&id=e4f73c88&scoped=true"
import script from "./FakeUserGameProfile.vue?vue&type=script&lang=js"
export * from "./FakeUserGameProfile.vue?vue&type=script&lang=js"
import style0 from "./FakeUserGameProfile.vue?vue&type=style&index=0&id=e4f73c88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f73c88",
  null
  
)

export default component.exports